var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('p',[_vm._v("Initializing household...")]),_c('p',{staticStyle:{"color":"red"},domProps:{"textContent":_vm._s(_vm.errorMessage)}})])}
var staticRenderFns = []

export { render, staticRenderFns }